export default __webpack_public_path__ + "static/media/3010.364bb14b.jpg";